<template>
  <div class="lwgl" v-on:scroll="handleScroll" >
    <div style="text-align: left; line-height: 25px">
      <p>在 Python 中，对于函数的参数传递，有两种主要的方式：传值和传引用。事实上，Python 的参数传递是一种“传对象引用”的方式。接下来的文章我们将详细介绍 Python 的函数参数传递机制，这对理解 Python 编程语言的底层实现以及优化你的代码都非常有帮助。
      </p>
    </div>
    <div style="text-align: left; line-height: 20px;">
      <p style="font-weight: bold">一.什么是浅拷贝和深拷贝</p>
      <p></p>
      <p>浅拷贝和深拷贝在Python中的对象参数传递中是一个非常重要的概念。</p>
      <p>浅拷贝是不拷贝子对象的内容，只拷贝子对象的引用。深拷贝是连子对象的内存也全部拷贝一份，对子对象的修改不修改源对象。</p>
      <p>这样说起来还是非常的抽象，我们来使用代码和图解来分析一下什么是浅拷贝和深拷贝，以及进行浅拷贝和深拷贝是内存中发生了什么。</p>
      <p></p>
      <p>Python中提供了copy模块，copy模块主要用于数据之间的拷贝。它提供了两个函数：</p>
      <p>copy.copy(object)：浅拷贝，返回object的浅拷贝</p>
      <p>copy.deepcopy(object)：深拷贝，返回object的深拷贝</p>
      <p></p>
      <p>我们使用这两个函数来测试浅拷贝与深拷贝</p>
      <p></p>
      <p style="font-weight: bold">二.浅拷贝</p>
      <p></p>
      <p>我们以下面这段代码进行测试</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step}}
              </span>步</span>
              <el-button size="mini" @click="nextStep" v-if="step >= 0 && step < 9">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step >= 3">a:[10,20,[5,6]]</div>
            <div v-if="step >= 4">b:[10,20,[5,6]]</div>
            <div v-if="step >= 7">浅拷贝结果：</div>
            <div v-if="step >= 8 ">a:[10,20,[5,6,7]]</div>
            <div v-if="step >= 9 ">b:[10,20,[5,6,7],30]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center; color: white">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target3">

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target4">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target1" >
                        <span v-if="step > 1">变量 b -> (94832830448320)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target2" >
                        <span v-if="step >= 1">变量 a -> (94832830448320)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 20px">
                  <div style="font-weight: bolder; text-align: center; color: white">堆</div>
                  <div style="display: flex; justify-content: center; color: white">

                    <div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step >= 1" >
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; color: white" id="aAim">10</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " id="aAimValue2">20</div>
                        <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" id="aAimValue3">
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4">引</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">6</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1" v-if="step >= 6">7</div>
                        </div>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row;"  v-if="step >= 2">
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520; color: white" id="bAim">10</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520; ">20</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520; " >引</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520" v-if="step >= 5">30</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>这段代码简单易懂，我们来探究一下，代码运行过程中内存中到底发生了什么。</p>
      <p>我们知道，Python中生成的对象都放在堆中，变量放在栈中，变量存放的不是对象的值，而是对象的地址（引用）。明白了这些，我们来分析第一段代码：</p>
      <p></p>
      <p>a=[10,20,[5,6]]</p>
      <p>b=copy.copy(a)</p>
      <p>新建了一个列表a，这个列表中有一个元素依然是列表，然后对a进行浅拷贝，并把返回结果存放到了b。可见浅拷贝的确是像我们之前说的那样，它不拷贝子对象的内容，只拷贝子对象的引用。也就是只拷贝了a指向的那个对象（父亲），并没有拷贝a指向对象的引用（儿子）</p>
      <p>b.append(30)</p>
      <p>b[2].append(7)</p>
      <p>可见，我们最后想要打印出来的a和b分别是[10,20,[5,6,7]]和[10,20,[5,6,7],30]，a中没有30，但是b中有7，这就是浅拷贝的结果。</p>
    </div>
    <div style="text-align: left; line-height: 20px;">
      <p style="font-weight: bold">三.深拷贝</p>
      <p>我们依然使用这段代码来说明深拷贝，只是copy.copy()改成了copy.deepcopy()</p>
      <div style="display: flex; justify-content: space-between">
        <div style="background-color: #2B2B2B; color: white; width: 50%; border-radius: 15px; padding: 10px">
          <div style="border: 1px solid #585858">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode1" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: max-content">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>

          <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
            <div style="display: flex; justify-content: space-between; align-items: center">

              <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step1}}
              </span>步</span>
              <el-button size="mini" @click="nextStep1" v-if="step1 >= 0 && step1 < 9">下一步<i
                class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button icon="el-icon-caret-right" type="success" size="mini" @click="startStep1">重新运行
              </el-button>
            </div>
          </div>
          <div>Console</div>
          <div style="border: 1px solid #585858; color: white; padding: 5px">
            <div v-if="step1 >= 3">a:[10,20,[5,6]]</div>
            <div v-if="step1 >= 4">b:[10,20,[5,6]]</div>
            <div v-if="step1 >= 7">浅拷贝结果：</div>
            <div v-if="step1 >= 8 ">a:[10,20,[5,6]]</div>
            <div v-if="step1 >= 9 ">b:[10,20,[5,6,7],30]</div>
          </div>
        </div>
        <div style="width: calc(50% - 20px); border-radius: 15px; background-color: #2B2B2B">
          <!-- 堆 栈 表示区域 -->
          <div style="width: 100%; height: max-content;  border-radius: 15px">
            <div style="width: 100%; height: max-content; border-radius: 15px">
              <div style="border: solid 1px #585858; border-radius: 15px; text-align: center; color: white">
            Python虚拟机全局数据区
          </div>
              <div
                style="display: flex; justify-content: space-around; height: max-content; padding: 10px; margin-top: 10px; font-size: 15px">
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 10px">
                  <div style="font-weight: bolder; text-align: center; color: white">栈</div>
                  <div style="display: flex; justify-content: center">
                    <div style="background-color: #d3dce6">
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target31">

                      </div>
                      <div style="width: 200px; height: 50px; border: 1px solid #4c88ff" id="target41">

                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target11" >
                        <span v-if="step1 > 1">变量 b -> (94832830448320)</span>
                      </div>
                      <div
                        style="width: 200px; height: 50px; border: 1px solid #4c88ff; line-height: 50px; text-align: center"
                        id="target21" >
                        <span v-if="step1 >= 1">变量 a -> (94832830448320)</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div style="width: 45%; border: solid 1px #585858; line-height: 30px; padding-bottom: 20px">
                  <div style="font-weight: bolder; text-align: center; color: white">堆</div>
                  <div style="display: flex; justify-content: center; color: white">

                    <div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; " v-if="step1 >= 1" >
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; color: white" id="aAim1">10</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #0000f4; " >20</div>
                        <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                          <div style="width: 50px; height: 50px; border: 1px solid #0000f4">引</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">6</div>
                        </div>
                      </div>
                      <div style=" line-height: 50px; text-align: center; display: flex; flex-direction: row; margin-top: 20px"  v-if="step1 >= 2">
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520; color: white" id="bAim1">10</div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520; ">20</div>
                        <div style="line-height: 50px; text-align: center; display: flex; flex-direction: column;" >
                          <div style="width: 50px; height: 50px; border: 1px solid #f52520">引</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">5</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1">6</div>
                          <div style="width: 50px; height: 50px; border: 1px solid #f5dab1" v-if="step1 >= 6">7</div>
                        </div>
                        <div style="width: 50px; height: 50px; border: 1px solid #f52520" v-if="step1 >= 5">30</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>分析一下第一段代码中内存中的情况</p>
      <p></p>
      <p>a=[10,20,[5,6]]</p>
      <p>b=copy.deepcopy(a)</p>
      <p>新建了一个列表a，这个列表中有一个元素依然是列表，然后对a进行深拷贝，并把返回结果存放到了b。可见深拷贝是连子对象的内存也全部拷贝一份（父亲和儿子全都拷贝），但是对子对象的修改不修改源对象。</p>
      <p>b.append(30)</p>
      <p>b[2].append(7)</p>
      <p>所有的修改都作用在了b上，而a没有发生任何的改变，对比浅拷贝，深拷贝真的是把父对象和子对象全部拷贝了一份。</p>
    </div>
  </div>


</template>

<script>
  import {
    qryPaperList,
    uploadImgUrl,
    uploadPdfUrl,
    qryPaperTypeList,
    updatePaperInfo,
    delPaperInfo,
    authToken
  } from '../../request/api';
  import LeaderLine from 'leader-line-vue';

  export default {
    data() {
      return {
        step: 0,
        zhichuandi: true,
        zcdCode: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "a=[10,20,[5,6]]", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "b=copy.copy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(\"a:\",a)", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "print(\"b:\",b)", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "b.append(30)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "b[2].append(7)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "print(\"浅拷贝结果：\")", a: "?", b: "?", fk: false, nk: false},
          {id: 15, ml: 0, con: "print(\"a:\",a)", a: "?", b: "?", fk: false, nk: false},
          {id: 16, ml: 0, con: "print(\"b:\",b)", a: "?", b: "?", fk: false, nk: false},
          {id: 17, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        step1: 0,
        zcdCode1: [
          {id: 1, ml: 0, con: "#!/usr/bin/python", a: "?", b: "?", fk: false, nk: false},
          {id: 2, ml: 0, con: "# -*- coding: UTF-8 -*-", a: "?", b: "?", fk: false, nk: false},
          {id: 3, ml: 0, con: "import copy", a: "?", b: "?", fk: false, nk: false},
          {id: 4, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 5, ml: 0, con: "a=[10,20,[5,6]]", a: "?", b: "?", fk: false, nk: false},
          {id: 6, ml: 0, con: "b=copy.deepcopy(a)", a: "?", b: "?", fk: false, nk: false},
          {id: 7, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 8, ml: 0, con: "print(\"a:\",a)", a: "?", b: "?", fk: false, nk: false},
          {id: 9, ml: 0, con: "print(\"b:\",b)", a: "?", b: "?", fk: false, nk: false},
          {id: 10, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 11, ml: 0, con: "b.append(30)", a: "?", b: "?", fk: false, nk: false},
          {id: 12, ml: 0, con: "b[2].append(7)", a: "?", b: "?", fk: false, nk: false},
          {id: 13, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
          {id: 14, ml: 0, con: "print(\"深拷贝结果：\")", a: "?", b: "?", fk: false, nk: false},
          {id: 15, ml: 0, con: "print(\"a:\",a)", a: "?", b: "?", fk: false, nk: false},
          {id: 16, ml: 0, con: "print(\"b:\",b)", a: "?", b: "?", fk: false, nk: false},
          {id: 17, ml: 0, con: "", a: "?", b: "?", fk: false, nk: false},
        ],
        zcd: {
          main: {
            a: '?',
            b: '?',
          },
          swap: {
            a: '?',
            b: '?',
            t: '?',
          },
          swapShow: false,
        },
        answerVisible: false,
        answerInfoVisible: false,
        answerInfoSuccessVisible: false,
        zcdAnswer: {
          a: '',
          b: ''
        },
        showStep: true,
        nowScore: 0,
        close: false,
        xLeaderLine: null,
        yLeaderLine: null,
        xLeaderLine1: null,
        yLeaderLine1: null,
      };
    },
    methods: {
      handleScroll() {
        if (this.xLeaderLine != null) {
          this.xLeaderLine.position();
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.position();
        }
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.position();
        }
        if (this.yLeaderLine1 != null) {
          this.yLeaderLine1.position();
        }
      },
      startStep() {
        this.step = 0;
        this.zcdStepCon();
        if (this.xLeaderLine != null) {
          this.xLeaderLine.remove();
          this.xLeaderLine = null
        }
        if (this.yLeaderLine != null) {
          this.yLeaderLine.remove();
          this.yLeaderLine = null
        }
      },
      startStep1() {
        this.step1 = 0;
        this.zcdStepCon();
        if (this.xLeaderLine1 != null) {
          this.xLeaderLine1.remove();
          this.xLeaderLine1 = null
        }
        if (this.yLeaderLine1 != null) {
          this.yLeaderLine1.remove();
          this.yLeaderLine1 = null
        }
      },
      nextStep() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step++;
          this.zcdStepCon();
        }
      },
      nextStep1() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step1++;
          this.zcdStepCon1();
        }
      },

      checkAnswer() {
        if (this.zcdAnswer.a !== '10' && this.zcdAnswer.a !== '5') {
          this.answerVisible = false;
          this.answerInfoVisible = true;
        } else {
          this.answerVisible = false;
          this.answerInfoSuccessVisible = true;
          this.nowScore = 20
        }
      },


      zcdStepCon() {
        // 第二步
        this.zcdCode.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step === 1) {

          this.zcdCode[4].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#aAim');
            const target2 = document.querySelector('#target2');
            this.xLeaderLine = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step === 2) {
          // 第二步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[5].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#bAim');
            const target1 = document.querySelector('#target1');
            this.yLeaderLine = LeaderLine.setLine(target1, targetAim);
          });

        } else if (this.step === 3) {
          // 第三步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[7].fk = true;

        } else if (this.step === 4) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[8].fk = true;

        } else if (this.step === 5) {
          this.$nextTick(() => {
            this.yLeaderLine.position()
            this.xLeaderLine.position()
          })
          // 第四步
          this.zcdCode[10].fk = true;

        } else if (this.step === 6) {
          // 第四步
          this.$nextTick(() => {
            this.yLeaderLine.position()
            this.xLeaderLine.position()
          })
          this.zcdCode[11].fk = true;

        } else if (this.step === 7) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[13].fk = true;

        } else if (this.step === 8) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[14].fk = true;

        } else if (this.step === 9) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[15].fk = true;

        }

      },
      zcdStepCon1() {
        // 第二步
        this.zcdCode1.forEach(item => {
          item.fk = false;
          item.nk = false;
        });
        if (this.step1 === 1) {

          this.zcdCode1[4].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#aAim1');
            const target2 = document.querySelector('#target21');
            this.xLeaderLine1 = LeaderLine.setLine(target2, targetAim);
          });

        } else if (this.step1 === 2) {
          // 第二步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[5].fk = true;

          this.$nextTick(() => {
            // 在DOM元素上初始化LeaderLine
            const targetAim = document.querySelector('#bAim1');
            const target1 = document.querySelector('#target11');
            this.yLeaderLine1 = LeaderLine.setLine(target1, targetAim);
          });

        } else if (this.step1 === 3) {
          // 第三步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[7].fk = true;

        } else if (this.step1 === 4) {
          // 第四步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[8].fk = true;

        } else if (this.step1 === 5) {
          // 第四步
          this.$nextTick(() => {
            this.yLeaderLine1.position();
            this.xLeaderLine1.position();
          })
          this.zcdCode1[10].fk = true;

        } else if (this.step1 === 6) {
          // 第四步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[11].fk = true;

        } else if (this.step1 === 7) {
          // 第四步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[13].fk = true;

        } else if (this.step1 === 8) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[14].fk = true;

        } else if (this.step1 === 9) {
          // 第四步
          this.zcdCode1.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode1[15].fk = true;

        }

      }
    },
    beforeDestroy() {
      if (this.xLeaderLine != null) {
        this.xLeaderLine.remove();
        this.xLeaderLine = null
      }
      if (this.yLeaderLine != null) {
        this.yLeaderLine.remove();
        this.yLeaderLine = null
      }
      if (this.xLeaderLine1 != null) {
        this.xLeaderLine1.remove();
        this.xLeaderLine1 = null
      }
      if (this.yLeaderLine1 != null) {
        this.yLeaderLine1.remove();
        this.yLeaderLine1 = null
      }
    },
    destroyed() {

    },
    mounted() {

    },
    props: ["itemData"]
  };
</script>

<style lang="less">
  .lwgl {
    background-color: #EFF3FF;
    padding: 20px;
    height: calc(100vh - 216px);
    overflow-y: auto;
    line-height: 27px;
    font-size: 16px;
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .lwgl .el-table .el-table__body-wrapper {
    height: calc(100vh - 455px);
    min-height: 250px;
    overflow-y: auto;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .searchClass .el-form--inline .el-form-item__content {
    margin-top: 13px;
  }

</style>




// WEBPACK FOOTER //
// src/components/lw/lwgl02.vue